var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { qboui } from './styles.js';
let ContextMenu = class ContextMenu extends LitElement {
    constructor() {
        super(...arguments);
        this._open = false;
        this.target = '';
        this.parent = null;
        this.menu = null;
        this.showContextMenu = (event) => {
            event.preventDefault();
            this._open = true;
            this._updateMenuPosition(event);
        };
    }
    static { this.styles = [
        qboui
    ]; }
    connectedCallback() {
        super.connectedCallback();
        this.getContextTarget();
        document.addEventListener('click', this._handleClickOutside.bind(this));
    }
    getContextTarget() {
        if (this.target) {
            this.parent = this.closest(this.target)
                ?? ((() => {
                    const rootNode = this.getRootNode();
                    if (rootNode instanceof ShadowRoot || rootNode instanceof Document) {
                        return rootNode.querySelector(this.target);
                    }
                    return null;
                })())
                ?? document.querySelector(this.target)
                ?? document;
        }
        else
            this.parent = this.parentElement;
        this.parent.addEventListener('contextmenu', this.showContextMenu);
    }
    disconnectedCallback() {
        if (this.parent)
            this.parent.removeEventListener('contextmenu', this.showContextMenu);
        document.removeEventListener('click', this._handleClickOutside.bind(this));
    }
    _handleClickOutside(event) {
        if (this._open && !this.shadowRoot?.contains(event.target) && !this.contains(event.target)) {
            this._open = false;
        }
    }
    async _updateMenuPosition(event) {
        event.preventDefault();
        this._open = true;
        await this.updateComplete;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const menuWidth = this.offsetWidth || 0;
        const menuHeight = this.offsetHeight || 0;
        // Calculate adjusted x and y positions
        let x = event.clientX;
        let y = event.clientY;
        if (x + menuWidth > viewportWidth) {
            x = viewportWidth - menuWidth;
        }
        if (y + menuHeight > viewportHeight) {
            y = viewportHeight - menuHeight;
        }
        console.log(`mouse event: ${event.clientX} x ${event.clientY} ; ${x} x ${y}`);
        this.style.left = x + 'px';
        this.style.top = y + 'px';
    }
    _handleClose() {
        this._open = false;
    }
    render() {
        return html `${this._open ? html `<slot></slot>` : ''}`;
    }
};
__decorate([
    state(),
    __metadata("design:type", Object)
], ContextMenu.prototype, "_open", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], ContextMenu.prototype, "target", void 0);
ContextMenu = __decorate([
    customElement('qbo-contextmenu')
], ContextMenu);
export { ContextMenu };
